import React from "react";
import {CommentsIcon} from "./icons";
import {Config} from "../../config";

export const LiveChatToggler = () => {
    const config = Config.getInstance();
    // Two independent gates, both server-driven:
    //  - is_admin: live help is an admin-panel feature, never shown to clients on
    //    the public booking widget.
    //  - live_agent_available: the sb:call_support listener (htdocs/common/js/support.js)
    //    is only loaded for SimplyBook.me-branded companies, so partner / white-label /
    //    reseller admins get no button instead of one whose click does nothing.
    if (!config.is_admin || !config.live_agent_available) {
        return null;
    }

    return (
        <button
            className="btn btn--secondary-outline sb-chat--livetoggle"
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent('sb:call_support'))}
        >
            <CommentsIcon />
            <span className={'btn__txt'}>Contact Live agent</span>
        </button>
    );
};
